// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.aboutmobile_container_about__tOSTE {
  width: 60%;
  margin-top: 3%;
  margin-left: 15%;
  display: flex;
  flex: 1 1;
  flex-direction: column;
  align-content: flex-start;
  align-items: flex-start;
  align-self: center;
}

.aboutmobile_about_info__bOVez{
 display: flex ;
 flex-direction: row;
  align-content: flex-start;
  align-items: flex-start;
  align-self: flex-start;
 align-content: space-between;
 justify-content: space-between;
}

.aboutmobile_about_info_text__3FMg3{
 display: flex ;
 flex-direction: column;
 align-items: flex-start;
 align-content: space-between;
 justify-content: center;
 width: 40%;
}


.aboutmobile_about_signup_block__xIWSH{
 display: flex ;
 flex-direction: column;
 align-items: center;
 align-content: center;
 align-self: center;
 padding-top: 60px;
}

.aboutmobile_logos__NwlCU {
  width: 100%;
  height:80px;
  margin-bottom: 20px;
  }

.aboutmobile_imageGroup_department_logos__nM6Ca {
  display: flex;
  flex: 1 1;
  flex-direction: column;
  align-content: flex-start;
  align-items: flex-start;
  align-self: flex-start;

}

`, "",{"version":3,"sources":["webpack://./src/pages/About/aboutmobile.module.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,SAAO;EACP,sBAAsB;EACtB,yBAAyB;EACzB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;CACC,cAAc;CACd,mBAAmB;EAClB,yBAAyB;EACzB,uBAAuB;EACvB,sBAAsB;CACvB,4BAA4B;CAC5B,8BAA8B;AAC/B;;AAEA;CACC,cAAc;CACd,sBAAsB;CACtB,uBAAuB;CACvB,4BAA4B;CAC5B,uBAAuB;CACvB,UAAU;AACX;;;AAGA;CACC,cAAc;CACd,sBAAsB;CACtB,mBAAmB;CACnB,qBAAqB;CACrB,kBAAkB;CAClB,iBAAiB;AAClB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB;;AAEF;EACE,aAAa;EACb,SAAO;EACP,sBAAsB;EACtB,yBAAyB;EACzB,uBAAuB;EACvB,sBAAsB;;AAExB","sourcesContent":[".container_about {\r\n  width: 60%;\r\n  margin-top: 3%;\r\n  margin-left: 15%;\r\n  display: flex;\r\n  flex: 1;\r\n  flex-direction: column;\r\n  align-content: flex-start;\r\n  align-items: flex-start;\r\n  align-self: center;\r\n}\r\n\r\n.about_info{\r\n display: flex ;\r\n flex-direction: row;\r\n  align-content: flex-start;\r\n  align-items: flex-start;\r\n  align-self: flex-start;\r\n align-content: space-between;\r\n justify-content: space-between;\r\n}\r\n\r\n.about_info_text{\r\n display: flex ;\r\n flex-direction: column;\r\n align-items: flex-start;\r\n align-content: space-between;\r\n justify-content: center;\r\n width: 40%;\r\n}\r\n\r\n\r\n.about_signup_block{\r\n display: flex ;\r\n flex-direction: column;\r\n align-items: center;\r\n align-content: center;\r\n align-self: center;\r\n padding-top: 60px;\r\n}\r\n\r\n.logos {\r\n  width: 100%;\r\n  height:80px;\r\n  margin-bottom: 20px;\r\n  }\r\n\r\n.imageGroup_department_logos {\r\n  display: flex;\r\n  flex: 1;\r\n  flex-direction: column;\r\n  align-content: flex-start;\r\n  align-items: flex-start;\r\n  align-self: flex-start;\r\n\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container_about": `aboutmobile_container_about__tOSTE`,
	"about_info": `aboutmobile_about_info__bOVez`,
	"about_info_text": `aboutmobile_about_info_text__3FMg3`,
	"about_signup_block": `aboutmobile_about_signup_block__xIWSH`,
	"logos": `aboutmobile_logos__NwlCU`,
	"imageGroup_department_logos": `aboutmobile_imageGroup_department_logos__nM6Ca`
};
export default ___CSS_LOADER_EXPORT___;
